import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Sidebar } from './Sidebar';
import { EnhancedHeader } from './EnhancedHeader';
import { HelpButton } from './help';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { Lead } from '../types/lead';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  if (!user) {
    return null;
  }

  const handleNavigate = (page: string) => {
    navigate(page);
  };

  const handleLeadSelect = (lead: Lead) => {
    // Navigate to pipeline page with lead details
    console.log('Lead selected:', lead);
    // Navigate to pipeline page and pass the lead ID as state
    navigate('/pipeline', { state: { selectedLeadId: lead.id } });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar 
        currentPage={location.pathname}
        onNavigate={handleNavigate}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      
      <div className="flex-1 flex flex-col">
        <EnhancedHeader 
          onLeadSelect={handleLeadSelect}
          currentUser={{
            name: user.name || 'User',
            role: user.role || 'Unknown',
            avatar: user.avatar
          }}
          onUserMenuClick={() => logout()}
        />
        
        <main className="flex-1 p-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            {children}
          </motion.div>
        </main>
      </div>

      {/* Help Button - Floating on all pages */}
      <HelpButton pageRoute={location.pathname} />
    </div>
  );
};